import './styles.scss'

export default function ModalBody({ children }) {
    return (
        <div className="modal-body">
            <div className="modal-body__content">{children}</div>
        </div>
    )
}